import {
    getFirstRenderPartByResource,
    getImageResourceSize,
    getResource
} from "../../../Providers/TemplateInstanceProvider";
import React, {useMemo, useRef, useState} from "react";
import {calculateCropRect, cropRectToImagePosition, getBoxSize, getCropRectFillInByProduct} from "../../../../utils";
import {useRecentImages} from "../../hooks/recentimages";
import useDrag from "../../hooks/useDrag";
import EpmsImage from "../../../Common/EpmsImage";
import useTemplateInstance from "../../hooks/useTemplateInstance";

const CropImage = ({resource, template, handleCropUpdate, scaleRatio, handleCropComplete}) => {
    const renderPart = getFirstRenderPartByResource(resource, template)
    const [state] = useTemplateInstance();

    const scaledRenderPart = useMemo(() => {
        return {
            width: renderPart.size.width * scaleRatio,
            height: renderPart.size.height * scaleRatio,
            x: renderPart.position.x * scaleRatio,
            y: renderPart.position.y * scaleRatio,
        }
    }, [renderPart, scaleRatio])

    const image = useMemo( () => {
        console.log('The image memo!');
        return {width: resource.image.width, height: resource.image.height, uuid: resource.image.uuid}
    }, [resource.image.uuid])

    const containerSize = useMemo( () => {
        return {width: scaledRenderPart.width, height: scaledRenderPart.height}
    }, []);

    const startingPosition = useMemo( () => {
        const renderPart = getFirstRenderPartByResource(resource, state.template)

        const imageSize = getImageResourceSize(resource.image, renderPart);

        if (resource.image.cropRect) {
            console.log('StartingPosition, already have crop rect!')
            return cropRectToImagePosition(resource.image.cropRect, imageSize, containerSize, renderPart.image.adaption);
        }

        const pos = getBoxSize(renderPart.image.adaption, imageSize, containerSize);
        // Get crop rect for fill in:
        console.log('StartingPosition: Image size', pos, imageSize, renderPart);
        const cr = calculateCropRect(pos, imageSize, containerSize)
        const sp = cropRectToImagePosition(cr, imageSize, containerSize, renderPart.image.adaption);
        console.log('StartingPosition', cr, sp);
        return sp;
    }, [resource.image.rotation, resource.image.uuid, resource.image.cropRect])

    const styles = {
        position: 'absolute',
        boxSizing: 'border-box',
        width: scaledRenderPart.width + 'px',
        height: scaledRenderPart.height + 'px',
        top: scaledRenderPart.y + 'px',
        left: scaledRenderPart.x + 'px',
        border: 'none'
    }

    const effect = resource.image.overrideEffect || renderPart.image.effect || 'original'
    const rotation = resource.image.rotation;


    return <div style={styles} >
        <Image startingPosition={startingPosition} handleUpdate={handleCropUpdate}
               handleCropComplete={handleCropComplete} image={image}
               containerSize={containerSize} rotation={rotation} effect={effect} adaption={renderPart.image.adaption}
        />
    </div>
}

export default CropImage;

const Image = ({startingPosition, image, containerSize, handleUpdate, adaption, rotation, effect, handleCropComplete}) => {
    const imageRef = useRef();

    console.log('Starting position', startingPosition, containerSize);
    const options = useMemo(() => {
        console.log('Options rerender')
        return {
            containerSize,
            onUpdate: handleUpdate,
            onChange: handleCropComplete,
            adaption: adaption
        }
    }, [containerSize, image])

    const {
        picturePosition,
        eventHandlers,
        isDragging,
    } = useDrag(imageRef, startingPosition, options)


    const imageContainerStyle = {
        width: containerSize.width + 'px',
        height: containerSize.height + 'px',
        top: 0,
        left: 0,
        position: 'absolute',
        opacity: isDragging ? 0.5 : 0,
        boxSizing: 'border-box',
        // For some reason, this fixes overflow hidden issue in Safari
        zIndex: 0
    }

    const borderBox = {
        width: containerSize.width + 'px',
        height: containerSize.height + 'px',
        top: 0,
        left: 0,
        position: 'absolute',
        opacity: isDragging ? 0.5 : 0,
        border: '2px solid black',
        boxSizing: 'border-box',
        // For some reason, this fixes overflow hidden issue in Safari
        zIndex: 0
    }

    console.log('We are dragging?', isDragging);

    const imageStyle = {
        position: 'absolute',
        width: picturePosition.width + 'px',
        height: picturePosition.height + 'px',
        top: picturePosition.y + 'px',
        left: picturePosition.x + 'px',
        transform: 'translateZ(0)',
    };

    return <>
        <div style={borderBox}/>
        <div style={imageContainerStyle}>
            <div ref={imageRef} style={imageStyle} {...eventHandlers}>
                <EpmsImage style={{width: '100%', height: '100%'}} uuid={image.uuid} effect={effect} rotation={rotation}
                           size={640} forceVisible={true}/>
            </div>
        </div>
    </>
}